<template>
  <div class="pa-8">
    <v-row class="pt-4">
      <v-col>
        <home-current-page></home-current-page>
      </v-col>
    </v-row>
    <v-row class="pt-2">
      <v-col cols="12" sm="12" md="6" lg="6">
        <h2 class="title-page">Indicadores</h2>
        <h4 class="mt-2 subtitle-page">
          Use o campo de busca para selecionar uma bacia e visualizar dados.
        </h4>
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6">
        <indicators-map-search-form
          class="elevation-0"
          @result="searchResult = $event"
          @resultLocation="resultLocation($event)"
          @resetSearch="resetSearch"
          :idClick="idClick"
          from="indicators"
          category="Manancial"
        ></indicators-map-search-form>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <indicators-map
          ref="indicatorsMapRef"
          :search-result="searchResult"
          :location="location"
          @idClick="idClick = $event"
        ></indicators-map>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <indicators-cards
          ref="indicatorsCardRef"
          :location="location"
        ></indicators-cards>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <indicators-load-estimation
          ref="indicatorsLoadEstimationRef"
          :location="location"
        ></indicators-load-estimation>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="mt-8">
        <IndicatorsIceChartTable
          :location="location"
        ></IndicatorsIceChartTable>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="mt-8">
        <CardGrantingEffluentsChart
          ref="indicatorsCardGrantingEffluentsRef"
          :location="location"
        ></CardGrantingEffluentsChart>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import HomeCurrentPage from '../../components/common/HomeCurrentPage.vue';
import IndicatorsMap from '@/components/indicators/IndicatorsMap';
import IndicatorsMapSearchForm from '@/components/indicators/IndicatorsMapSearchForm';
import IndicatorsCards from '@/components/indicators/IndicatorsCards';
import IndicatorsLoadEstimation from '@/components/indicators/IndicatorsLoadEstimation';
import CardGrantingEffluentsChart from '@/components/indicators/IndicatorsCardsItems/CardGrantingEffluentsChart';
import IndicatorsIceChartTable from '@/components/indicators/IndicatorsIceChartTable';
export default {
  name: 'Indicators',
  components: {
    IndicatorsLoadEstimation,
    IndicatorsCards,
    IndicatorsMapSearchForm,
    IndicatorsMap,
    HomeCurrentPage,
    CardGrantingEffluentsChart,
    IndicatorsIceChartTable,
  },
  data() {
    return {
      searchResult: undefined,
      class: '',
      loading: false,
      value: 0,
      location: undefined,
      showAnimation: false,
      minDaysForecast: 29,
      maxDaysForecast: 6,
      idClick: undefined,
      isProduction: process.env.NODE_ENV === 'production' ? true : false,
      mapKey: 1,
    };
  },
  methods: {
    resultLocation(location) {
      this.location = location;
    },
    async getSearchResult(url) {
      this.searchResult = url;
    },
    async resetSearch() {
      this.location = undefined;
      this.searchResult = undefined;
      this.$store.commit('setGrantsEffluents', []);
      this.$store.commit('setSiaDetails', undefined);
      this.$store.commit('setIndicatorBovines', undefined);
      this.$refs.indicatorsCardRef.initializeErosion(undefined);
      this.$refs.indicatorsCardRef.initializeBovines(undefined);
      this.$refs.indicatorsLoadEstimationRef.sia = undefined;
      this.$refs.indicatorsLoadEstimationRef.initialize(undefined);
      this.$refs.indicatorsCardGrantingEffluentsRef.initialize(undefined);

      // Wait for the change to get flushed to the DOM
      await this.$nextTick();

      // set default map view
      const newView = this.$refs.indicatorsMapRef.$refs.mapBase.map.getView();
      newView.setCenter([-50.97197, -24.628277]);
      newView.setZoom(7);
      this.$refs.indicatorsMapRef.$refs.mapBase.map.setView(newView);
    },
  },
};
</script>

<style scoped>
.title-page {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 33px;
}

.subtitle-page {
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
}
</style>
